import React, { useState } from 'react'
import { Navigate } from 'react-router'
import { Box, Container } from '@mui/material'
import { useIsUser } from 'pages/Identity/Login'
import EmployerKioskWelcomeStep from './employerKiosk/EmployerKioskWelcomeStep'
import EmployerKioskEmployerStep from './employerKiosk/EmployerKioskEmployerStep'
import EmployerKioskRecruiterStep from './employerKiosk/EmployerKioskRecruiterStep'
import EmployerKioskJobFormStep from './employerKiosk/EmployerKioskJobFormStep'
import EmployerKioskThankYouStep from './employerKiosk/EmployerKioskThankYouStep'

const initialWizardData = {
  employerId: null,
  employerName: '',
  employerUserId: null,
  firstName: '',
  lastName: '',
  email: '',
  matchCounts: null,
}

const EmployerKioskPage = () => {
  const { isSuper } = useIsUser()
  const [step, setStep] = useState(0)
  const [wizardData, setWizardData] = useState(initialWizardData)

  if (!isSuper) {
    return <Navigate to='/' replace />
  }

  const handleNext = () => setStep(prev => prev + 1)
  const handleBack = () => setStep(prev => prev - 1)

  const handleStartOver = () => {
    setStep(0)
    setWizardData(initialWizardData)
  }

  return (
    <Container maxWidth='md' sx={{ py: 4 }}>
      <Box>
        {step === 0 && <EmployerKioskWelcomeStep onNext={handleNext} />}
        {step === 1 && (
          <EmployerKioskEmployerStep
            wizardData={wizardData}
            setWizardData={setWizardData}
            onNext={handleNext}
            onBack={handleBack}
          />
        )}
        {step === 2 && (
          <EmployerKioskRecruiterStep
            wizardData={wizardData}
            setWizardData={setWizardData}
            onNext={handleNext}
            onBack={handleBack}
          />
        )}
        {step === 3 && (
          <EmployerKioskJobFormStep
            wizardData={wizardData}
            setWizardData={setWizardData}
            onNext={handleNext}
            onBack={handleBack}
          />
        )}
        {step === 4 && (
          <EmployerKioskThankYouStep
            wizardData={wizardData}
            onStartOver={handleStartOver}
          />
        )}
      </Box>
    </Container>
  )
}

export default EmployerKioskPage
